import React, { useState, Memo } from 'react';


import {
    Card,
    Checkbox,
    Button,
    Typography,
    List,
    ListItem,
    ListItemPrefix,
    ListItemSuffix,
    IconButton,
    Tab,
    Tabs,
    TabsHeader,

} from "@material-tailwind/react";

import {
    FunnelIcon,
    HandThumbUpIcon,
    FolderArrowDownIcon,
    XMarkIcon
} from "@heroicons/react/24/outline";

const taskxmlHeader = `<ISO11783_TaskData VersionMajor="3" VersionMinor="0" ManagementSoftwareManufacturer="Agro-Technology" ManagementSoftwareVersion="0.7.19" DataTransferOrigin="1">
<CTR A="CTR1" B="Not defined"/>
<FRM A="FRM1" B="{fieldname}" I="CTR1"/>
<PFD A="PFD1" C="{ownername}" D="{area}" F="FRM1" E="CTR1">
<PLN A="1" B="Field boundary" C="{area}">`;


const taskxmlTail = `</PLN>
</PFD>
<PGP A="PGP1" B="Seeds"/>
<VPN A="VPN1" B="0" C="0.01" D="2" E="{unit}"/>
<CPC A="CPC1" B="Seed"/>
<PDT A="PDT1" B="seed" C="PGP1" D="VPN1" E="004B"/>
<TSK A="TSK1" B="{date}" D="FRM1" C="CTR1" E="PFD1" G="1" H="1" J="0">
<DLT A="DFFF" B="31"/>
<TZN A="0" B="Out of field">
<PDV A="0006" B="0" C="PDT1" E="VPN1"/>
</TZN>
<TZN A="1" B="Field">
<PDV A="0006" B="0" C="PDT1" E="VPN1"/>
</TZN>
<OTP A="CPC1"/>
<GRD A="{bottom}" B="{left}" C="{cellnorth}" D="{celleast}" E="{xpixels}" F="{ypixels}" G="GRD001" I="2" J="1"/>
</TSK>
</ISO11783_TaskData>`;



import JSZip from 'jszip';
import { saveAs } from 'file-saver';

import * as turf from '@turf/turf'
import { pointToPolygonDistance } from "@turf/point-to-polygon-distance";

import { showAlert } from './Alert.jsx';

import FertilizationDosesCard from './FertilizationDosesCard.jsx';
import { getAnalizy, getFieldFiles } from './AdminTools.jsx';

import { get10mBoundingBox, generateGrid, getBBoxWidthAndHeight } from './GeoTools.jsx';
import { getUserFiles } from './AdminTools.jsx';
import FertilizationMap from './FertilizationMap.jsx';

const emptyGeoJson = {
    type: "FeatureCollection",
    features: []
}




export default function FertilizationCard(props) {
    const [featureCollection, setFeatureCollection] = useState(JSON.parse(localStorage.getItem("featureCollection")) || emptyGeoJson);
    const [fields, setFields] = useState(JSON.parse(localStorage.getItem("fields")) || []);
    const [files, setFiles] = useState(JSON.parse(localStorage.getItem("files")) || []);


    const [ownerid, setOwnerId] = useState();
    const [clientName, setClientName] = useState(props.clientname);
    const [shape, setShape] = useState();
    const [action, setAction] = useState('create');
    const [fieldid, setFieldId] = useState(props.fieldid || 0);
    const [results, setResults] = useState();
    const [boundingBox, setBoundingBox] = useState();
    const [mapStyle, setMapStyle] = useState({ position: 'relative', width: '100%', height: '86vh' });

    const [clearOnExit, setClearOnExit] = useState(false);
    const [authenticated, setAuthenticated] = useState(localStorage.getItem("authenticated") || false);

    const [session, setSession] = useState(localStorage.getItem("session") || null);
    const [showFileCard, setShowFileCard] = useState(false);

    const [parameter, setParameter] = useState(localStorage.getItem("parameter") || "value");
    const [stage, setStage] = useState("init");

    const [refreshAfterExit, setRefreshAfterExit] = useState(false);
    const [closeOnSend, setCloseOnSend] = useState(false);


    const [outputFeatures, setOutputFeatures] = useState({ type: "FeatureCollection", features: [] });
    const [labFeatures, setLabFeatures] = useState({ type: "FeatureCollection", features: [] });
    const [mapFeatures, setMapFeatures] = useState({ type: "FeatureCollection", features: [] });
    const [showDosesCard, setShowDosesCard] = useState(false);

    const selectedFeatures = { type: "FeatureCollection", features: [] };


    React.useEffect(() => {
        setOwnerId(props.clientid);
        setFieldId(props.fieldid);

        console.log("PROPS");
        console.log(props);
        focusAll();
        //init(props);
        localStorage.setItem("lockvehicles", "true");
        //if (props.fieldid) getFieldFiles(session, props.fieldid, updateFiles,"json");   //// important    
        featureCollection.features.forEach(element => {
            if (!element.properties.selected) element.properties.value = 0;
            element.properties.label = "";
            if (!element.properties.selected) element.properties.selected = 0;
        })
        setBoundingBox(getBoundingBox(featureCollection));
        setMapFeatures(featureCollection);

        console.log("featureCollection");
        console.log(featureCollection);
        if (fieldid>0) selectFeatureByFieldId(fieldid);

    }, []);


    React.useEffect(() => {
        let res = files.filter(f => f.category == "results");
        //setResults(res);
        console.log("Fields");
        console.log(fields);

        console.log("Results");
        console.log(res);
    }, [files]);


    React.useEffect(() => {
        //if ((ownerid > 0) && (featureCollection.features.length > 0)) getUserFiles(session, ownerid, startCollecting)
        //if (stage == "selected") startGeneratingGrid();

    }, [featureCollection]);

    React.useEffect(() => {
        //if ((ownerid > 0) && (featureCollection.features.length > 0) && (stage == "selected")) getUserFiles(session, ownerid, startCollecting)
    }, [mapFeatures]);


    React.useEffect(() => {
        applyBoundingBox(boundingBox);
    }, [labFeatures]);



    function prepareField(stage) {
        if (stage == "getfiles") {
            if ((ownerid > 0) && (selectedFeatures.features.length > 0)) 
                {
                    showAlert("green", "Analizuję wyniki badań - to może chwilę potrwać", 4000);    
                    getUserFiles(session, ownerid, startCollecting);
                }
        }

        if (stage == "generategrid") generate10mGrid();

        if (stage == "performmatching") {
            if (mapFeatures.features.length > 0) {
                if (labFeatures.features.length > 0) {
                    matchMapFeaturesWithLab();
                }
            }
        }
        if (stage == "alldone") {
            setFeatureCollection(selectedFeatures);
            setMapFeatures({ ...mapFeatures });
            setLabFeatures({ ...labFeatures });
            setStage("getdoses");
        }

    }



    function init(props) {
        if (props.fieldid > 0) {
            setAction('update');

            let fieldarray = fields.filter(f => f.id == props.fieldid);
            if (fieldarray.length == 1) {
                let field = fieldarray[0];
                setOwnerId(field.owner);
                setName(field.name);
                setCrops(field.crops);
                setDescription(field.description);
                setArea(field.area);


                if (field.shape) {
                    //add a bit of delay for better rendering
                    //showGeoJson(JSON.parse(field.shape), false);
                }
            }
        }
    }


    function handleFileCardClose(refresh) {
        if ((refresh) && (fieldid)) getFieldFiles(session, props.fieldid, setFiles);
        setShowFileCard(false);
    }

    function zeroPad(n) {
        return n > 9 ? "" + n : "0" + n;
    }


    function getBoundingBox(features) {
        let bounds = turf.bbox(features);
        let resizedbounds = resizeBoundingBox(bounds);
        return resizedbounds;
    }


    function resizeBoundingBox(bounds) {
        var point1 = turf.point([bounds[0], bounds[1]]);
        var point2 = turf.point([bounds[2], bounds[3]]);
        var bearing = turf.bearing(point1, point2);
        var distance = turf.distance(point1, point2);
        var p1 = turf.destination(point1, -0.1 * distance, bearing);
        var p2 = turf.destination(point2, 0.1 * distance, bearing);
        var box = [p1.geometry.coordinates[0], p1.geometry.coordinates[1], p2.geometry.coordinates[0], p2.geometry.coordinates[1]];
        return box;
    }


    function applyFeatures(collection) {
        dispatchEvent(new CustomEvent("featureCollectionChangedPanel", { detail: { features: collection } }));
    }

    function applyBoundingBox(bounds) {
        dispatchEvent(new CustomEvent('boundingBoxChangedPanel', { detail: { bounds: bounds } }));
    }

    function applyLabFeatures(collection) {
        dispatchEvent(new CustomEvent("labFeatureCollectionChangedPanel", { detail: { labFeatures: collection } }));
    }

    function applySelectedParameter(parameter) {
        dispatchEvent(new CustomEvent("selectedParameterChangedPanel", { detail: { selected: parameter } }));
    }

    function applyMinMax(min, max) {
        dispatchEvent(new CustomEvent("minMaxChangedPanel", { detail: { min: min, max: max } }));
    }




    function closeDosesCard(dosedata) {
        if (dosedata) {
            dosedata.timestamp= Date.now();
            featureCollection.fertilize = dosedata;
            mapFeatures.fertilize = dosedata;
            console.log(featureCollection);
            setStage("getzip");
        }
        setShowDosesCard(false);
    }

    function openDosesCard() {
        setShowDosesCard(true);
    }



    function cancelClose() {
        //localStorage.setItem("parameter", "value");
        localStorage.setItem("lockvehicles", "false");
        localStorage.removeItem("parameter");
        console.log("close on send : " + closeOnSend);

        if (clearOnExit) {
            applyFeatureCollection(emptyGeoJson);
        }
        props.Close(refreshAfterExit);
    }



    var shpwrite = require("shp-write-update");

    function download_default() {
        var options = {
            folder: 'granice',
            types: {
                point: 'points',
                polygon: 'granice',
                polyline: 'lines'
            },
            file: 'granice'

        }
        // a GeoJSON bridge for features
        let parsed = JSON.parse(shape);
        console.log('downloading shape');
        console.log(parsed);
        shpwrite.download(parsed, options);
    }


    function focusAll() {
        let bounds = turf.bbox(featureCollection);
        let resizedbounds = resizeBoundingBox(bounds);
        //setBoundingBox(bounds);
        applyBoundingBox(resizedbounds);
    }


    function getLastExam(examined) {
        //console.log('get last exam');
        //console.log(examined);
        examined.sort((a, b) => b.timestamp - a.timestamp); //sort descending
        return examined[0];

    }


    function cutToSelected() {
        var newfc = {
            "type": "FeatureCollection",
            features: []
        }
        console.log("cut to selected");

        for (var idx = 0; idx < featureCollection.features.length; idx++) {
            if ((featureCollection.features[idx].selected) && (featureCollection.features[idx].selected == 1)) {
                let feature = featureCollection.features[idx];
                feature.selected = 1;
                feature.properties.value = 0.5;
                newfc.features.push(feature);
            }
        }
        if (newfc.features.length != 1) {
            showAlert("red", "Wybierz 1 pole do nawożenia", 3000);
            return;
        }

        applyFeatures(newfc);

        console.log("newfc after cut");
        console.log(newfc);
        let bounds = turf.bbox(newfc,);
        let resizedbounds = resizeBoundingBox(bounds);

        applyBoundingBox(resizedbounds); //panel map box only
        setBoundingBox(resizedbounds);
        //setFeatureCollection(newfc); //this will restart map so try to avoid
        //setStage("selected"); //this will restart map so try to avoid

        selectedFeatures.features = newfc.features;
        console.log("Selected Features")
        console.log(selectedFeatures);

        prepareField("getfiles");

        return;
    }


    function selectFeatureByFieldId(fieldid)
    {
        console.log("Autoselect field " + fieldid );
        if (fields.length<1) return; // skip yet
        console.log("fields");
        console.log(fields);
        var index=fields.findIndex((field) => field.id == fieldid);
        
        console.log("index " + index );
        if (featureCollection.features.length>index) 
            {
                featureCollection.features[index].selected=1;
                console.log("cut now ");
                cutToSelected();
            }
    }




    function isLabFeatureMatchingFC(labfeat) {
        var matching = false;
        featureCollection.features.forEach(feature => {
            if ((turf.booleanContains(feature, labfeat) == true) || (turf.booleanOverlap(feature, labfeat) == true)) { matching = true; }
        });

        return matching;
    }

    function getMatchingLabFeature(labfeat) {
        var result = null;
        selectedFeatures.features.forEach(feature => {
            if (turf.booleanContains(feature, labfeat) == true) { result = labfeat; return result; }
            if (turf.booleanOverlap(feature, labfeat) == true) {
                var inter = turf.intersect(feature, labfeat)
                console.log(inter);
                if ((inter) && (inter.geometry.type = "Polygon")) {
                    result = inter;
                    result.properties = labfeat.properties;
                    return result;
                }
            }
        });


        return result;
    }


    function extractPolygons(featCol) {

        featCol.features.forEach(feat => {
            if (feat.geometry.type == "MultiPolygon") {

                for (var idx = 0; idx < feat.geometry.coordinates.length; idx++) {
                    var part = getPoly(feat, idx);
                    part.properties = Object.assign({}, feat.properties);
                    featCol.features.push(part);
                }
            }
        });
        for (var i = featCol.features.length - 1; i >= 0; i--) {
            if (featCol.features[i].geometry.type == "MultiPolygon") { delete featCol.features[i]; }
            else if (featCol.features[i].geometry.type == "Point") delete featCol.features[i];
        }

    }


    function startCollecting(data) {
        
        setTimeout(() => collectLabFiles(data), 500);
    }


    function collectLabFiles(data) {
        console.log('collect');
        console.log(featureCollection);
        if (!selectedFeatures) return;
        if (!selectedFeatures.features) return;

        var allowed = [];
        selectedFeatures.features.forEach(feature => {
            if (feature.examined) {
                feature.examined.forEach(exam => {
                    allowed.push(Number(exam.fileid));
                })
            }
        });

        console.log("data");
        console.log(data);
        labFeatures.features.length = 0; //clear lab feautres
        console.log("allowed");
        console.log(allowed);


        data.forEach(file => {
            const dstr = file.date;
            const [y, m, d] = dstr.split(/-|\//); // splits "26-02-2012" or "26/02/2012"
            const date = new Date(y, m - 1, d);
            var filetimestamp = date.getTime();
            if (allowed.length > 0) {
                if (!allowed.includes(Number(file.id))) { console.log('skip'); return; }
            }

            if ((file.category == "results") && (file.jsondata)) {
                var filefeaturescollection = JSON.parse(file.jsondata);
                if (!filefeaturescollection.features) return;
                filefeaturescollection.features.forEach(filefeature => {
                    try
                    {
                    var feat = getMatchingLabFeature(filefeature);
                    if (feat) labFeatures.features.push(feat);
                    }
                    catch (ex) { 
                        console.log(ex);
                        console.log('filefeature');    
                        console.log(filefeature);    
                    }
                    
                });

            };



        });
        console.log('labFeatures');
        console.log(labFeatures);
        if (labFeatures.features.length == 0) {
            console.log("brak badań")
            showAlert("yellow", "Nie odnaleziono badań dla tego pola", 4000);
            return;
        }

        prepareField("generategrid");
        //applyLabFeatures(labFeatures);

        //setLabFeatures(labFeatures); //----------------     this will restart map


    }


    function startGeneratingGrid() {
        //showAlert("green", "Analizuję wyniki badań - to może chwilę potrwać", 5000);
        setTimeout(() => generate10mGrid(), 200);
    }


    function getPoly(multi, index) {
        var polygon = {
            type: "Feature",
            geometry: {
                type: "Polygon",
                coordinates: []
            },
            properties: {}
        }
        polygon.geometry.coordinates = multi.geometry.coordinates[index];
        //console.log(polygon);
        return polygon;
    }


    /*
        function addToShape(feature) {
            feature.properties = {};
            feature.properties.value = 0.85;
            shape.features.push(feature);
        }
    */

    function matchMapFeaturesWithLab() {
        console.log('MATCH start, map features:');
        //console.log(mapFeatures);
        //console.log('lab features:');
        //console.log(labFeatures);
        var unmatched = [];
        var found = false;


        mapFeatures.features.forEach(square => {

            var center = turf.centerOfMass(square);
            found = false;

            labFeatures.features.forEach(lab => {

                if (turf.booleanPointInPolygon(center, lab) == true) {
                    square.properties = Object.assign(square.properties, lab.properties); //merge properties
                    found = true;
                }

            });
            if (found == false) unmatched.push(square);

        });
        console.log('match finished');
        //console.log(mapFeatures);
        //console.log('umatched ');
        //console.log(unmatched);
        if (unmatched.length > 0) {
            unmatched.forEach(square => {

                //console.log('square');
                //console.log(square);
                var center = turf.center(square);
                var mindist = 1000000;
                var dist = 0, minidx;

                for (var i = 0; i < labFeatures.features.length; i++) {
                    var labfeat=labFeatures.features[i];
                    var dist = 0;

                    if (labfeat.geometry.coordinates.length>1)
                    {
                        //console.log('multiple coordinates');
                        ///console.log(labfeat);
                        labfeat.geometry.coordinates = labfeat.geometry.coordinates[0];
                        //console.log(labfeat);
                    }    
                    
                    
                    try {
                        var labcenter = turf.center(labfeat);
                        dist = turf.distance(center, labcenter);
                    }
                    catch (ex) {
                        //console.log('catch ' + ex);
                        //console.log(labFeatures.features[i]);
                        dist = 10000;
                    }

                    if (dist < mindist) {
                        mindist = dist;
                        minidx = i;
                    }
                }
                square.properties = Object.assign(square.properties, labFeatures.features[minidx].properties); //merge properties
            });
        }
        //setMapFeatures(mapFeatures); //will restart map
        applyFeatures(mapFeatures);

        prepareField("alldone");
    }


    function addXMLPoints(content, feature) {
        //<PNT A="10" C="53.57813" D="15.603912"/>
        console.log("feature");
        console.log(feature);
        console.log("fgc length");
        console.log(feature.geometry.coordinates.length);

        console.log("fgc0 length");
        console.log(feature.geometry.coordinates[0].length);

        console.log("at 0 0 0");
        console.log(feature.geometry.coordinates[0][0][0])
        for (var ring=0; ring<feature.geometry.coordinates.length;ring++)
        {
        content += '<LSG A="1">';    
        feature.geometry.coordinates[ring].forEach(coords => {
            content += '<PNT A="10" C="' + coords[1].toFixed(7) + '" D="' + coords[0].toFixed(7) + '"/>';
        });
        content += '</LSG>';    
        }
        return content;
    }


    function getFertilizerDose(feature, parameter, dosearray) {
        var dose = 0, doseindex;

        if (parameter in feature.properties) {
            doseindex = Math.round(feature.properties[parameter]);
            if ((dosearray) && (doseindex < dosearray.length)) dose = dosearray[doseindex] * 100;
        }
        return dose;
    }




    function generateZipFile() {
        const zip = new JSZip();
        const bin = zip.folder("TASKDATA");

        
        var x = mapFeatures.xpix;
        var y = mapFeatures.ypix;
        var doses = mapFeatures.fertilize.doses;
        var parameter=mapFeatures.fertilize.parameter;
        var ownername=mapFeatures.fertilize.ownername;
        var fieldname=mapFeatures.fertilize.fieldname;
        var doseunit=mapFeatures.fertilize.doseunit;;
        //binary file section        
        var buffer = new ArrayBuffer(4 * x * y);
        let array = new Uint32Array(buffer);
        mapFeatures.features.forEach(feature => {
            if ((feature.properties.index) && (feature.properties.essential == true))
                array[feature.properties.index] = getFertilizerDose(feature, parameter, mapFeatures.fertilize.doses);
        });

        var binary = new Blob([array], { type: "octet/stream" })
        bin.file("GRD001.bin", binary);

        //xml file section    

        const xml = zip.folder("TASKDATA");
        var xmlcontent = taskxmlHeader;
        console.log("map Features is");
        console.log(mapFeatures);

        console.log("featureCollection is");
        console.log(featureCollection);
        featureCollection.features.forEach(feature => {
            xmlcontent = addXMLPoints(xmlcontent, feature);
        });

        xmlcontent += taskxmlTail;

        var celleast = mapFeatures.celleast;
        var cellnorth = mapFeatures.cellnorth;
        var bbox = mapFeatures.bbox;
        //console.log('width ' + width);
        //console.log('height ' + height);
        //console.log('w * h ' + width * height);
        console.log(bbox);

        console.log('bbox');
        console.log(bbox);
        var area = turf.area(featureCollection);
        //<GRD A="{bottom}" B="{left}" C="{cellnorth}" D="{celleast}" E="{xpixels}" F="{ypixels}" G="GRD001" I="2" J="1"/>
        xmlcontent = xmlcontent.replace("{xpixels}", x);
        xmlcontent = xmlcontent.replace("{ypixels}", y);
        xmlcontent = xmlcontent.replace("{celleast}", celleast.toFixed(9));
        xmlcontent = xmlcontent.replace("{cellnorth}", cellnorth.toFixed(9));

        xmlcontent = xmlcontent.replace("{ownername}", ownername);
        xmlcontent = xmlcontent.replace("{fieldname}",fieldname);
        xmlcontent = xmlcontent.replace("{unit}",doseunit);

        xmlcontent = xmlcontent.replace("{bottom}", bbox[1].toFixed(8));
        xmlcontent = xmlcontent.replace("{left}", bbox[0].toFixed(8));
        xmlcontent = xmlcontent.replaceAll("{area}", Math.round(area));

        console.log('xmlcontent');
        console.log(xmlcontent);


        xml.file("TASKDATA.xml", xmlcontent);

        zip.generateAsync({ type: "blob" }).then(function (content) {
            // see FileSaver.js
            saveAs(content, "IsoXML.zip");
        });
    }


    
    
    var shpwrite = require("shp-write-update");

    function download_shape() {
        var options = {
            folder: 'application',
            types: {
                point: 'points',
                polygon: 'siatka',
                polyline: 'lines'
            },
            file: 'application'

        }
        // a GeoJSON bridge for features
        
        console.log('downloading shape');
        console.log(outputFeatures);
        shpwrite.download(outputFeatures, options);
        
    }


    
    function generateShapeFile() {
        if (!mapFeatures.fertilize) return;
        
        var parameter= mapFeatures.fertilize.parameter;
        var doses = mapFeatures.fertilize.doses;
        var feature;
        for (var index=0;index<labFeatures.features.length;index++)
        {
            feature=labFeatures.features[index];
            if (parameter in feature.properties) outputFeatures.features.push(feature);
        }
        //just lab features that contain required parameter
        for (index=0;index<outputFeatures.features.length;index++)
        {
            feature=outputFeatures.features[index];
            feature.properties.RATE=getFertilizerDose(feature, parameter, doses)/100;
        }
        setMapFeatures(outputFeatures);
        download_shape();
        setStage("closeit");
    }




    function generate10mGrid() {
        console.log("Gen 10grid");


        console.log("get bbox");
        var bbox = get10mBoundingBox(selectedFeatures);
        var area = Math.round(turf.area(selectedFeatures)/10000);
        console.log(' area ' + area);
        var side=10; //10m Grid size as default
        /*
        if (area>30 && area<=120) side=20;
        if (area>120 && area<=270) side=30;
        if (area>270) side=40;
        */
        var grid = generateGrid(bbox,side);
        
        var [celleast, cellnorth, x, y] = getBBoxWidthAndHeight(selectedFeatures);
        var shape = {
            "type": "FeatureCollection",
            features: []
        }

        mapFeatures.bbox = bbox;
        mapFeatures.celleast = celleast;
        mapFeatures.cellnorth = cellnorth;
        mapFeatures.xpix = x;
        mapFeatures.ypix = y;

        console.log("Generating grid for selectedFeatures");
        console.log(selectedFeatures);

        selectedFeatures.features.forEach(feature => {
            grid.features.forEach(square => {

                var result = turf.booleanContains(feature, square);

                if (result == true) {
                    if (!square.properties) square.properties = {};
                    square.properties.value = 0.80;
                    square.properties.essential = true;
                    square.properties.boolContains = true;
                    shape.features.push(square);
                } else {
                    result = turf.booleanOverlap(feature, square);
                    if (result == true) {
                        var feat = turf.intersect(feature, square);
                        if (feat) {

                            if (feat.geometry.type == "Polygon") {
                                if (!feat.properties) feat.properties = {};
                                feat.properties.value = 0.80;
                                feat.properties.essential = true;
                                feat.properties.intersect = "poly";
                                shape.features.push(feat);
                            }
                            if (feat.geometry.type == "MultiPolygon") {
                                //shape.features.push(feat);
                                //find bigest subpolygon
                                var maxarea = 0, maxidx = 0;
                                var part;
                                for (var idx = 0; idx < feat.geometry.coordinates.length; idx++) {

                                    part = getPoly(feat, idx);
                                    var area = turf.area(part);
                                    if (area > maxarea) { maxarea = area; maxidx = idx; }
                                }

                                for (idx = 0; idx < feat.geometry.coordinates.length; idx++) {

                                    part = getPoly(feat, idx);
                                    if (!part.properties) part.properties = {};
                                    part.properties.value = 0.80;
                                    part.properties.intersect = "multi";
                                    if (idx == maxidx) part.properties.essential = true;
                                    shape.features.push(part);
                                }


                            }
                        }
                        else {
                            console.log("Catch null feat");
                        }
                    } //if Overlap

                } //else if turf.contains

            });


        });
        console.log("instersections end");
        console.log(shape);
        //setMapFeatures(shape);
        mapFeatures.features = shape.features;
        let bounds = turf.bbox(shape);
        let resizedbounds = resizeBoundingBox(bounds);
        //setBoundingBox(resizedbounds);
        applyBoundingBox(resizedbounds); //quiet update
        prepareField("performmatching");

    }

    const MemoPanel = React.memo(Panel);

    function Panel(props) {
        //        const [featureCollection, setFeatureCollection] = useState(JSON.parse(localStorage.getItem("featureCollection")) || emptyGeoJson);
        //        const [featureCollection, setFeatureCollection] = useState(props.features);

        const [labParams, setLabParams] = useState(JSON.parse(localStorage.getItem("labparams")) || []);

        const [selectedParam, setSelectedParam] = useState(localStorage.getItem("parameter") || "value");
        
        const [analizy,setAnalizy] = useState(JSON.parse(localStorage.getItem("analizy")) || []);
        const [min, setMin] = useState(0);
        const [max, setMax] = useState(1);
        const [side] = useState(props.side);
        

        React.useEffect(() => {
            //init(props);
            featureCollection.features.forEach(element => {
                if (!element.properties.value) element.properties.value = 0;
                element.properties.label = "";

            })
            console.log("Panel Reinit ");
        
            if (analizy.length==0) getAnalizy(session,collectAnalizy);
            if (selectedParam!=="value") changeParameter(selectedParam); //reload with selected parameter

            addEventListener('labFeatureCollectionChangedPanel', quietLabFeaturesUpdate);
            return () => {
                removeEventListener('labFeatureCollectionChangedPanel', quietLabFeaturesUpdate);
            }
            

        }, []);




        function collectAnalizy(data)
        {
            console.log("collect ");
            console.log(data)                        
            localStorage.setItem("analizy",JSON.stringify(data));
            setAnalizy(data);
        }


        React.useEffect(() => {
            //setSelectedParam(props.parameter);
            //localStorage.setItem("parameter", props.parameter);
            //console.log("Panel refresh parameter");
        }, [props.parameter]);

        React.useEffect(() => {
            console.log("Panel refresh labfeatures");
            parseLabParams(props.labfeatures);
        }, [props.labsfeatures]);



        function quietLabFeaturesUpdate(e) {
            parseLabParams(e.detail.labFeatures);
        }


        function parseLabParams(collection) {
            let allkeys = [];
            collection.features.forEach(element => {
                let keys = Object.keys(element.properties);
                keys.forEach(key => {
                    if (!allkeys.includes(key)) allkeys.push(key);
                })
            });
            if (allkeys.includes('gpsnr')) allkeys.splice(allkeys.indexOf('gpsnr'), 1);
            if (allkeys.includes('value')) allkeys.splice(allkeys.indexOf('value'), 1);
            //setParameter("value"); //-----------------------------------------------------------
            allkeys.push("selected");
            setLabParams(allkeys);
            //localStorage.setItem("labparams", JSON.stringify(allkeys));
            //if (allkeys.length > 0) handleParamChange(null);
        }



        function changeResults(rid) {
            console.log("changing results");
            let file = files.filter(f => f.id == rid)[0];
            try {
                let collection = JSON.parse(file.jsondata);

                setFeatureCollection(collection);
                parseLabParams(collection);

            } catch { };
        };


        function getValue(value, _min, _max) {

            let _step = (_max - _min) / 4;
            if (_step < 0.1) _step = 0.1;
            let _v = _min;
            for (_v = _min; value <= _max; value += _step)
                if (_v > value) break;
            return _v;
        }


        function updateFeaturesColor(parameter, search, min, max) {

            if (search == true) {
                min = 1000; max = 0;
                console.log(mapFeatures);
                mapFeatures.features.forEach(element => {    //was labFeatures
                    let value = element.properties[parameter];
                    //element.properties.color = getColor(value); 
                    if (value < min) min = value;
                    if (value > max) max = value;
                })
                console.log('Min,Max Search completed');
            }
            console.log('min ' + min);
            console.log('max ' + max);
            console.log("parameter " + parameter);
            console.log("search " + search);

            mapFeatures.features.forEach(element => {   //was labFeatrues
                let value = element.properties[parameter];
                element.properties.value = getValue(value, min, max);
                //element.properties.polygonName = "" + value;
                //element.properties.label = "" + value;
            })

            console.log('mapfeatures @ updateFeatureColor');
            console.log(mapFeatures);
            setMapFeatures(mapFeatures);
            applyFeatures(mapFeatures);
            applyMinMax(min, max);
        }

        function changeParameter(newparam)
        {
            localStorage.setItem("parameter", newparam);
            setSelectedParam(newparam);
            
            //applySelectedParameter(newparam); //not needed
            
            if (selectedParam=="value") 
                {
                    console.log("selected param was " + selectedParam);
                    //applyFeatures(mapFeatures);
                }

            let _min, _max;
            let search = true;

            if (newparam.startsWith('Ocena')) {
                _min = 1; _max = 5; search = false;
            }
            else {
                search=true;
                if (newparam == "Mg") {
                    _min = 5;
                    _max = 100;
                    search = true;
                }
                if (newparam == "K2O") {
                    _min = 4;
                    _max = 25;
                }
                if (newparam == "P2O5") {
                    _min = 4;
                    _max = 35;
                }
                if (newparam.startsWith('ph')) {
                    _min = 3;
                    _max = 11;
                }
                if (newparam.startsWith('selected')) {
                    _min = 0;
                    _max = 1;
                    search = false;
                }
                
            }

            if (search == true) {
                _min = 1000; _max = 0;
                console.log(mapFeatures);
                mapFeatures.features.forEach(element => {    //was labFeatures
                    let value = element.properties[newparam];
                    //element.properties.color = getColor(value); 
                    if (value < _min) _min = value;
                    if (value > _max) _max = value;
                })
                console.log('Min,Max Search completed');
            }

            setMin(_min);
            setMax(_max);
            console.log("update colors")
            
            //updateFeaturesColor(newparam, search, _min, _max);
            applyMinMax(_min, _max); //a bit faster that update colors 
            
            //console.log(featureCollection);

        }


        function handleParamChange(e) {
            let newparam = labParams[0];
            if (e.currentTarget)
            {
                newparam = e.currentTarget.getAttribute("data-param");
                changeParameter(newparam);
            }


        }


        return (
            <>
                <div id="map" className='rounded-lg border w-full border-green-200 p-1'>
                    <div className='mx-auto w-full rounded-lg bg-gray-500 h-0 my-0 selected:text-black'>
                        {labParams.length > 0 && <Tabs value={selectedParam}>
                            <TabsHeader className='text-sm h-12 bg-black/50 shadow-none !text-blue-500'>
                                {
                                    labParams.map(param => {
                                        let friendlyname = param;
                                        var analiza=analizy.find(a => a.sysname===param);
                                        if (analiza) friendlyname=analiza.shortname;
                                        /*
                                        switch (param) {
                                            case "Ocena_ph": friendlyname = "Ocena PH"; break;
                                            case "Ocena_p2o5": friendlyname = "Ocena Fosforu"; break;
                                            case "Ocena_k2o": friendlyname = "Ocena Potasu"; break;
                                            case "Ocena_mg": friendlyname = "Ocena Magnezu"; break;
                                            case "ph_gleby": friendlyname = "Wartość PH"; break;
                                            case "P2O5": friendlyname = "Fosfor"; break;
                                            case "K2O": friendlyname = "Potas"; break;
                                            case "MG": friendlyname = "Magnez"; break;

                                        }
                                        */
                                        if (param != "selected")
                                            return (
                                                <Tab key={param} value={param} data-param={param} className={`text-sm ${param === selectedParam ? "bg-white text-black" : "bg-black/50 text-white"}`} onClick={handleParamChange}>
                                                    {friendlyname}
                                                </Tab>
                                            )
                                    })}
                            </TabsHeader>
                        </Tabs>
                        }
                    </div>

                    <FertilizationMap features={mapFeatures} selected={selectedParam} boundingBox={boundingBox} min={min} max={max} showLegend={true} side={side} style={mapStyle} results={results} showNumbers={true}  onChangeResults={changeResults} />
                    {showDosesCard && <FertilizationDosesCard close={closeDosesCard} fieldname={''} fieldfc={featureCollection} clientname={clientName} features={mapFeatures} parameter={selectedParam} analizy={analizy} />}
                </div>
            </>
        )
    }


    //const MemoPanel=React.memo(Panel);

    function selectFieldItem(e) {
        const idx = e.currentTarget.getAttribute("data-fieldindex");
        console.log('select field' + idx);
        console.log(featureCollection);
        setFeatureCollection(featureCollection);
        let feature = featureCollection.features[idx];
        let bounds = turf.bbox(feature);
        let resizedbounds = resizeBoundingBox(bounds);

        //setBounds[bounds];

        applyBoundingBox(resizedbounds); //panel map box only
        //setBoundingBox(resizedbounds);
        //applyFeatures(featureCollection);
        //applyFocused(feature);
    }

    function selectFieldByIndex(index, selected) {
        console.log('select field by index ' + index + ' new state ' + selected);
        console.log(featureCollection);

        let feature = featureCollection.features[index];
        let selVal = 0;
        if (selected==true) selVal = 1;
        
        feature.selected = selVal;
        feature.properties.value = selVal / 2;
        /*
        if (selected==true) { feature.properties.value=1; }
            else { feature.properties.value=0; }
        */

        //setFeatureCollection({ ...featureCollection});
        applyFeatures(featureCollection);
        setMapFeatures(featureCollection); //works but refreshes whole map
        //applyFocused(feature);
    }





    function SingleField(props) {
        const [checked, setChecked] = useState(props.selected || false);
        const [index] = useState(props.index);
        const [content] = useState(props.content);
        const [fieldid] = useState(props.fieldid);
        //const [fieldName, setFieldName] = useState(props.name);


        React.useEffect(() => {
            setChecked(props.selected);
        }, [props.selected]);


        function toggle() {
            setChecked(!checked);
            selectFieldByIndex(index, !checked);
            setParameter("value"); //-----------------------------------------------------------------------------
            //changeFieldChecked(props.index,!checked);
        }



        return (
            <ListItem key={index} className='py-0 px-0 mx-0 text-sm w-full' data-fieldindex={index} >
                <ListItemPrefix className='p-0 m-0'>
                    <Checkbox size="sm" className='m-auto p-0 w-4 h-4 rounded-md' checked={checked} onChange={toggle}></Checkbox>
                </ListItemPrefix>
                <div className='whitespace-pre-wrap' data-fieldindex={index} onClick={selectFieldItem}> {content}</div>
                <ListItemSuffix >{props.examval}</ListItemSuffix>
            </ListItem>
        )
    }



    function RenderFieldFeatureList(param) {

        if (!Array.isArray(param.collection.features)) return;
        return (
            param.collection.features.map(({ properties, area, examined, fieldid, selected, exam_percent }, index) => {
                var content = (index + 1).toString();
                content = "";
                if (properties.nazwa) { content += "  " + properties.nazwa; }
                else if (properties.name) { content += "  " + properties.name; }
                else content += "  Pole bez nazwy "
                var examstr = "";
                if (area) content += " (" + area + " ha)";
                if (examined) {
                    var last = getLastExam(examined);

                    if (last.timestamp > 0) {
                        var date = new Date(last.timestamp);
                        content += " Przebadane " + date.getFullYear() + "-" + zeroPad(date.getMonth() + 1) + "-" + zeroPad(date.getDate());
                    }

                    if (last.percent > 0) examstr = last.percent.toString() + "%";
                } //if examined
                return (
                    <SingleField key={index} index={index} content={content} examval={examstr} selected={selected} fieldid={fieldid} />

                )
            } //map
            )
        )
    }







    return (

        <div className='fixed w-full h-full top-0 left-0 items-center justify-center m-auto z-[20] flex place-content-center bg-black/50 '>

            <Card color="white" className="w-auto w-[95vw] mx-auto rounded-lg shadow-lg h-[95vh] " shadow={true}>

                <div className="flex justify-between gap-2 w-auto mt-2">
                    <Typography color="gray" className="mt-0 pl-12 font-normal mx-auto">
                        Karta Aplikacji Nawozów
                    </Typography>
                    <IconButton variant='text' className='-top-1 right-2' color="blue-gray" data-refresh={false} onClick={cancelClose}>
                        <XMarkIcon className='w-6 h-6' />
                    </IconButton>
                </div>
                <div id="all_items" className="w-auto flex flex-row items-start gap-2 m-2">

                    <div className='flex flex-col gap-1'>
                        <div id="list of client features" className='p-1 w-auto h-[80vh] overflow-y-auto overflow-x-hidden border border-green-100 rounded-lg'>

                            <div className="flex justify-between w-auto bg-green-100 rounded-lg"  >
                                <Typography color="Black" className="flex mt-0 p-2 font-normal mx-auto text-center cursor-pointer" onClick={focusAll}>
                                    Moje Pola
                                </Typography>
                            </div>

                            <List className='p-0 mr-1 w-full '>
                                <RenderFieldFeatureList collection={featureCollection} />
                            </List>


                        </div>
                        <div id="buttons panel" className="border border-green-200 h-12 rounded-lg p-auto items-center justify-center flex " >
                            {
                                stage == "init" && <Button className="flex items-center gap-1 p-2 m-auto text-center items-center w-auto h-9 mx-1" size="sm" color="green" onClick={cutToSelected}>
                                    <HandThumbUpIcon strokeWidth={2} className="flex h-auto w-[1.5rem] mx-auto" />
                                    <div className='flex mx-auto'>Wybierz pole do nawożenia</div>
                                </Button>
                            }
                            {stage == "getdoses" &&
                                <Button className="flex items-center gap-1 p-2 m-auto text-center items-center w-auto h-9 mx-1" size="sm" color="green" onClick={openDosesCard} >
                                    <FunnelIcon strokeWidth={2} className="h-auto w-[1.5rem] mx-auto" />
                                    <div className='flex mx-auto'>Dobierz dawkowanie</div>

                                </Button>
                            }
                            {stage == "getzip" &&
                                <>
                                <Button className="flex items-center gap-1 p-2 m-auto text-center items-center w-auto h-9 mx-1" size="sm" color="blue" onClick={generateZipFile} >
                                    <FolderArrowDownIcon strokeWidth={2} className="h-auto w-[1.5rem] mx-auto" />
                                    <div className='flex mx-auto px-1 normal-case'>Pobierz ISOxml</div>
                                </Button>
                                <Button className="flex items-center gap-1 p-2 m-auto text-center items-center w-auto h-9 mx-1" size="sm" color="blue" onClick={generateShapeFile} >
                                    <FolderArrowDownIcon strokeWidth={2} className="h-auto w-[1.5rem] mx-auto" />
                                    <div className='flex mx-auto px-1 normal-case'>Pobierz Shape</div>
                                </Button>
                                </>
                            }
                            {stage == "closeit" &&
                                <Button className="flex items-center gap-1 p-2 m-auto text-center items-center w-auto h-9 mx-1" size="sm" color="green" onClick={cancelClose} >
                                    <XMarkIcon strokeWidth={2} className="h-auto w-[1.5rem] mx-auto" />
                                    <div className='flex mx-auto px-1 normal-case'>Zamknij okno</div>
                                </Button>
                            }

                        </div>
                    </div>

                    <MemoPanel side="left" style={mapStyle} parameter={parameter} labfeatures={labFeatures} />
                </div>
            </Card>

        </div>

    );


}

